import React, { useState, useEffect } from "react";

const TimeOut = () => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setCount((prevCount) => prevCount + 1);
    }, 1000);

    return () => clearTimeout(timeout); // cleanup
  }, [count]);

  return <h1>I've rendered {count} times!</h1>;
};

export default TimeOut;
